(function () {
    'use strict';
  
    var DEBUG = true;
    var SESSION_ACTIVE = 'kt-radio-active';
    var SESSION_PLAYING = 'kt-radio-playing';
    var syncTimer = null;
    var booting = false;
    var stickyMounted = false;
  
    var PLAY_SVG =
      '<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-play" viewBox="0 0 10 14"><path fill="currentColor" fill-rule="evenodd" d="M1.482.815A1 1 0 0 0 0 1.69v10.517a1 1 0 0 0 1.525.851L10.54 7.5a1 1 0 0 0-.043-1.728z" clip-rule="evenodd"/></svg>';
    var PAUSE_SVG =
      '<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-pause" viewBox="0 0 8 12"><path fill="currentColor" d="M1.2.75c-.387 0-.7.235-.7.525v9.45c0 .29.313.525.7.525s.7-.235.7-.525v-9.45c0-.29-.313-.525-.7-.525m5.6 0c-.387 0-.7.235-.7.525v9.45c0 .29.313.525.7.525s.7-.235.7-.525v-9.45c0-.29-.313-.525-.7-.525"/></svg>';
    var SPINNER_SVG =
      '<svg class="icon-spinner" width="18" height="18" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><circle cx="9" cy="9" r="7" stroke="currentColor" stroke-width="2" stroke-dasharray="32" stroke-dashoffset="8" stroke-linecap="round"/></svg>';
  
    function dbg() {
      if (!DEBUG) return;
      try {
        //console.log.apply(console, ['[KT Radio]'].concat([].slice.call(arguments)));
      } catch (e) {}
    }
  
    function cfg() {
      var c = window.KT_ELFSIGHT_CFG || {};
      var host = getHost();
      var radioWidget =
        c.radioWidgetId ||
        (host && host.getAttribute('data-kt-radio-widget-id')) ||
        '1275fcd0-3ffb-48da-8962-cde2aceb5c6a';
      return {
        radio: radioWidget,
        header: radioWidget
      };
    }
  
    function isRadioPage() {
      return document.body.classList.contains('kt-radio-page-active');
    }
  
    function isRadioSession() {
      try {
        return sessionStorage.getItem(SESSION_ACTIVE) === '1';
      } catch (e) {
        return false;
      }
    }
  
    function setSession(active, playing) {
      try {
        if (active) sessionStorage.setItem(SESSION_ACTIVE, '1');
        else {
          sessionStorage.removeItem(SESSION_ACTIVE);
          sessionStorage.removeItem(SESSION_PLAYING);
        }
        if (playing) sessionStorage.setItem(SESSION_PLAYING, '1');
        else sessionStorage.removeItem(SESSION_PLAYING);
      } catch (err) {}
      dbg('setSession', { active: active, playing: playing });
    }
  
    function shouldResume() {
      try {
        return sessionStorage.getItem(SESSION_PLAYING) === '1';
      } catch (e) {
        return false;
      }
    }
  
    function getHost() {
      var radioHost = document.querySelector(
        '[data-kt-header-player-mount] .elfsight-host[data-kt-player-role="radio-page"]'
      );
      if (radioHost) return radioHost;
      var moved = document.querySelector('.header-elfsightplayer.radio-page-moved .elfsight-host');
      if (moved) return moved;
      return document.querySelector('.header-elfsightplayer.desktop_player .elfsight-host');
    }
  
    function getMirrors() {
      return document.querySelectorAll('[data-kt-player-role="mirror"]');
    }
  
    function queryDeep(root, selector) {
      var out = [];
      if (!root || !root.querySelectorAll) return out;
      try {
        root.querySelectorAll(selector).forEach(function (el) {
          out.push(el);
        });
        root.querySelectorAll('*').forEach(function (el) {
          if (el.shadowRoot) queryDeep(el.shadowRoot, selector).forEach(function (n) {
            out.push(n);
          });
        });
      } catch (e) {}
      return out;
    }
  
    function audioEl(host) {
      if (!host) return null;
      var list = queryDeep(host, 'audio');
      return list[0] || null;
    }
  
    function playBtn(host) {
      if (!host) return null;
      var selectors =
        '[class*="PlayPause__"] button, [class*="PlayPause__"] [aria-label], ' +
        '[class*="es-play-pause"], button[class*="es-play"], [class*="es-play"] button, ' +
        'button[aria-label="Play"], button[aria-label="Pause"], [aria-label="Play"], [aria-label="Pause"]';
      var list = queryDeep(host, selectors);
      for (var i = 0; i < list.length; i++) {
        var el = list[i];
        if (el.closest('.elfsight-custom-toggle')) continue;
        var label = (el.getAttribute('aria-label') || '').toLowerCase();
        if (label === 'play' || label === 'pause') return el;
        if (el.tagName === 'BUTTON' && el.closest('[class*="PlayPause__"], [class*="es-play"]')) return el;
      }
      return null;
    }
  
    function trackTitle(host) {
      if (!host) return '';
      var list = queryDeep(
        host,
        '.es-track-info-title, [class*="es-track-info-title"], [class*="es-track-info"], [class*="es-title"], [class*="Title"], [class*="TrackName"], [class*="Song"]'
      );
      for (var i = 0; i < list.length; i++) {
        var text = (list[i].textContent || '').trim();
        if (text) return text;
      }
      var audio = audioEl(host);
      if (audio && audio.getAttribute('title')) return audio.getAttribute('title').trim();
      return '';
    }
  
    function playing(host) {
      var audio = audioEl(host);
      if (audio) return !audio.paused && !audio.ended && audio.readyState > 2;
      var b = playBtn(host);
      return b ? (b.getAttribute('aria-label') || '').toLowerCase().indexOf('pause') > -1 : false;
    }
  
    function controlsReady(host) {
      return !!(playBtn(host) || audioEl(host));
    }
  
    function widgetRendered(host) {
      if (!host) return false;
      if (host.querySelector('iframe, audio, [class*="AudioPlayer__"], [class*="eapps-"]')) return true;
      if (audioEl(host)) return true;
      var root = host.querySelector('.es-embed-root');
      if (!root) return false;
      var html = (root.innerHTML || '').replace(/\s/g, '');
      if (html && html !== '<span></span>' && html !== '<span/>') return true;
      return !!queryDeep(root, 'audio, button, [class*="es-play"], [class*="es-track"], [class*="PlayPause__"]').length;
    }
  
    function embedStuck(host) {
      if (!host) return false;
      var app = host.querySelector('[class*="elfsight-app-"]');
      if (!app || !app.getAttribute('data-miwrid')) return false;
      return !widgetRendered(host);
    }
  
    function hostSnapshot(host) {
      if (!host) return { host: false };
      var btn = playBtn(host);
      var app = host.querySelector('[class*="elfsight-app-"]');
      return {
        role: host.getAttribute('data-kt-player-role'),
        widgetId: host.getAttribute('data-elfsight-widget-id'),
        appClass: app ? app.className : null,
        miwrid: app ? app.getAttribute('data-miwrid') : null,
        rendered: widgetRendered(host),
        playBtn: btn ? btn.getAttribute('aria-label') : null,
        title: trackTitle(host),
        isPlaying: playing(host),
        controlsReady: controlsReady(host),
        stuck: embedStuck(host),
        hasAudio: !!audioEl(host),
        embedHtml: host.querySelector('.es-embed-root, [class*="elfsight-app-"]')?.innerHTML?.slice(0, 120) || null
      };
    }
  
    function appWidgetId(host) {
      if (!host) return '';
      var app = host.querySelector('[class*="elfsight-app-"]');
      if (!app || !app.className) return '';
      var m = String(app.className).match(/elfsight-app-([a-f0-9-]+)/i);
      return m ? m[1] : '';
    }
  
    function kickWidget(widgetId) {
      if (!widgetId) return;
      try {
        if (window.eapps && window.eapps.apps && window.eapps.apps.requireWidget) {
          window.eapps.apps.requireWidget(widgetId);
        }
      } catch (e) {
        dbg('requireWidget error', e);
      }
      try {
        var plat = window.eapps && window.eapps.platform;
        if (plat) {
          if (typeof plat.revise === 'function') plat.revise();
          else if (typeof plat.collectWidgets === 'function') plat.collectWidgets();
        }
      } catch (e2) {
        dbg('platform revise error', e2);
      }
    }
  
    function ensurePlatform(cb) {
      function finish() {
        dbg('ensurePlatform finish', {
          eapps: typeof window.eapps,
          hasApps: !!(window.eapps && window.eapps.apps),
          hasRequireWidget: !!(window.eapps && window.eapps.apps && window.eapps.apps.requireWidget)
        });
        kickWidget(targetWidget());
        if (cb) cb();
      }
  
      if (window.eapps && window.eapps.apps) {
        finish();
        return;
      }
  
      var tag = document.querySelector('script[data-elfsight-platform]');
      if (tag) {
        dbg('ensurePlatform waiting for existing script', {
          loaded: tag.getAttribute('data-loaded'),
          readyState: tag.readyState
        });
        if (tag.getAttribute('data-loaded') === '1' || tag.readyState === 'complete') finish();
        else tag.addEventListener('load', finish, { once: true });
        return;
      }
  
      dbg('ensurePlatform injecting platform.js');
      tag = document.createElement('script');
      tag.src = 'https://elfsightcdn.com/platform.js';
      tag.async = true;
      tag.setAttribute('data-elfsight-platform', 'true');
      tag.addEventListener('load', function () {
        tag.setAttribute('data-loaded', '1');
        finish();
      });
      document.head.appendChild(tag);
    }
  
    function ensureApp(host, widgetId) {
      if (!host || !widgetId) return false;
  
      var mountedId = appWidgetId(host) || host.getAttribute('data-elfsight-widget-id') || '';
  
      if (mountedId === widgetId && (host.querySelector('.elfsight-app-' + widgetId) || widgetRendered(host))) {
        host.setAttribute('data-elfsight-widget-id', widgetId);
        dbg('ensureApp keep existing', { widgetId: widgetId, mountedId: mountedId });
        return false;
      }
  
      dbg('ensureApp mount widget', { widgetId: widgetId, mountedId: mountedId });
      host.setAttribute('data-elfsight-widget-id', widgetId);
      host.querySelectorAll('[class*="elfsight-app-"]').forEach(function (n) {
        n.remove();
      });
  
      var el = document.createElement('div');
      el.className = 'elfsight-app-' + widgetId;
      host.appendChild(el);
      kickWidget(widgetId);
      return true;
    }
  
    function targetWidget() {
      return cfg().radio;
    }
  
    function waitForControls(host, cb) {
      var tries = 0;
      (function poll() {
        tries++;
        var btn = playBtn(host);
        var ready = controlsReady(host);
        if (ready || tries > 120) {
          if (!ready && embedStuck(host) && tries > 40) {
            dbg(
              'widget embed stuck — add this domain in Elfsight dashboard (Settings → Domains), then hard-refresh',
              { host: location.hostname, widgetId: targetWidget(), snapshot: hostSnapshot(host) }
            );
          }
          dbg('waitForControls done', {
            tries: tries,
            ready: ready,
            playBtn: btn ? btn.getAttribute('aria-label') : null,
            snapshot: hostSnapshot(host)
          });
          if (cb) cb();
          return;
        }
        if (tries === 1 || tries % 10 === 0) {
          if (tries % 20 === 0) kickWidget(targetWidget());
          dbg('waitForControls polling', { tries: tries, snapshot: hostSnapshot(host) });
        }
        setTimeout(poll, 250);
      })();
    }
  
    function initWidget(cb) {
      var host = getHost();
      if (!host) {
        dbg('initWidget: no host');
        if (cb) cb();
        return;
      }
  
      var want = targetWidget();
      dbg('initWidget start', { want: want, snapshot: hostSnapshot(host) });
  
      ensurePlatform(function () {
        var swapped = ensureApp(host, want);
        if (swapped) kickWidget(want);
        waitForControls(host, cb);
      });
    }
  
    function syncStickyPlayer(isPlay, title, ready) {
      if (!isRadioPage()) return;
      var btn = document.getElementById('kt-radio-sticky-play');
      var titleEl = document.getElementById('kt-radio-sticky-title');
      if (!btn) return;
  
      if (!ready) {
        btn.innerHTML = SPINNER_SVG;
        btn.setAttribute('aria-label', 'Loading');
        btn.disabled = true;
      } else {
        btn.disabled = false;
        btn.innerHTML = isPlay ? PAUSE_SVG : PLAY_SVG;
        btn.setAttribute('aria-label', isPlay ? 'Pause' : 'Play');
      }
  
      if (titleEl) {
        titleEl.textContent = title || 'CRUMPLER RADIO';
      }
    }
  
    function syncUi() {
      var host = getHost();
      if (!host) {
        dbg('syncUi: no host');
        return;
      }
  
      var c = cfg();
      var wid = appWidgetId(host) || host.getAttribute('data-elfsight-widget-id');
      var ready = controlsReady(host);
      var isPlay = playing(host);
      var title = trackTitle(host);
  
      if (wid === c.radio && ready) setSession(true, isPlay);
  
      dbg('syncUi', {
        wid: wid,
        cfgRadio: c.radio,
        ready: ready,
        isPlay: isPlay,
        title: title,
        radioPage: isRadioPage(),
        session: { active: isRadioSession(), playing: shouldResume() },
        snapshot: hostSnapshot(host)
      });
  
      function paint(node) {
        if (!node) return;
        var btn = node.querySelector('.elfsight-custom-toggle');
        var mq = node.querySelector('.elfsight-custom-marquee span');
        var wrap = node.closest('.header-elfsightplayer');
        if (!btn) return;
        btn.disabled = false;
        btn.dataset.loading = ready ? '0' : '1';
        btn.dataset.state = isPlay ? 'playing' : 'paused';
        if (wrap) wrap.dataset.state = isPlay ? 'playing' : 'paused';
        if (mq && title) mq.textContent = title + ' \u2022 ' + title + ' \u2022 ';
        else if (mq && ready) mq.textContent = 'CRUMPLER RADIO \u2022 CRUMPLER RADIO \u2022 ';
      }
  
      paint(host);
      getMirrors().forEach(paint);
      syncStickyPlayer(isPlay, title, ready);
    }
  
    function clickPlay(done) {
      var host = getHost();
      if (!host) return;
  
      function fire() {
        var b = playBtn(host);
        var audio = audioEl(host);
        dbg('clickPlay fire', {
          btn: b ? b.getAttribute('aria-label') : null,
          hasAudio: !!audio,
          audioPaused: audio ? audio.paused : null
        });
        if (b) {
          try {
            b.click();
          } catch (e) {
            dbg('clickPlay error', e);
          }
        } else if (audio) {
          try {
            if (audio.paused) audio.play();
            else audio.pause();
          } catch (e2) {
            dbg('clickPlay audio error', e2);
          }
        }
        setTimeout(function () {
          syncUi();
          if (done) done();
        }, 350);
      }
  
      if (controlsReady(host)) fire();
      else initWidget(fire);
    }
  
    function mountStickyPlayer() {
      if (!isRadioPage() || stickyMounted || document.getElementById('kt-radio-sticky-player')) return;
  
      var html =
        '<div id="kt-radio-sticky-player" class="soundcloud-popup kt-radio-sticky-player show" aria-hidden="false">' +
        '<div class="soundcloud-popup-content" role="region" aria-label="Radio playback">' +
        '<div class="popup-header">' +
        '<div class="popup-controls">' +
        '<button type="button" class="popup-control-btn" id="kt-radio-sticky-play" aria-label="Play">' +
        PLAY_SVG +
        '</button></div>' +
        '<div class="track-title-box"><div class="track-title" id="kt-radio-sticky-title">CRUMPLER RADIO</div></div>' +
        '</div></div></div>';
  
      var isMobile = window.innerWidth <= 1025;
      var mobileContainer = document.querySelector('.mobile-soudbar-show');
  
      if (isMobile && mobileContainer) {
        mobileContainer.insertAdjacentHTML('afterbegin', html);
      } else {
        document.body.insertAdjacentHTML('beforeend', html);
      }
  
      var stickyBtn = document.getElementById('kt-radio-sticky-play');
      if (stickyBtn && stickyBtn.dataset.ktBound !== '1') {
        stickyBtn.dataset.ktBound = '1';
        stickyBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var host = getHost();
          if (!host) return;
          var c = cfg();
          var wid = appWidgetId(host) || host.getAttribute('data-elfsight-widget-id');
          clickPlay(function () {
            if (wid === c.radio) setSession(true, playing(host));
          });
        });
      }
  
      stickyMounted = true;
      syncUi();
    }
  
    function bindControls() {
      function bind(root) {
        var btn = root.querySelector('.elfsight-custom-toggle');
        if (!btn || btn.dataset.ktBound === '1') return;
        btn.dataset.ktBound = '1';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var host = getHost();
          if (!host) return;
          var c = cfg();
          var wid = appWidgetId(host) || host.getAttribute('data-elfsight-widget-id');
          clickPlay(function () {
            if (wid === c.radio) setSession(true, playing(host));
          });
        });
      }
  
      var host = getHost();
      if (host) bind(host);
      getMirrors().forEach(bind);
    }
  
    function resumeRadio() {
      if (!isRadioSession() || !shouldResume()) return;
      dbg('resumeRadio start');
      var c = cfg();
      var n = 0;
      function attempt() {
        n++;
        var host = getHost();
        if (!host) {
          dbg('resumeRadio: no host', { attempt: n });
          if (n < 15) setTimeout(attempt, 700);
          return;
        }
        var wid = appWidgetId(host) || host.getAttribute('data-elfsight-widget-id');
        if (wid !== c.radio) {
          dbg('resumeRadio: swap widget', { wid: wid, want: c.radio, attempt: n });
          ensureApp(host, c.radio);
          ensurePlatform(function () {
            kickWidget(c.radio);
            setTimeout(attempt, 800);
          });
          return;
        }
        if (playing(host)) {
          dbg('resumeRadio: already playing', { attempt: n });
          return;
        }
        var b = playBtn(host);
        var audio = audioEl(host);
        dbg('resumeRadio: click play', {
          attempt: n,
          btn: b ? b.getAttribute('aria-label') : null,
          hasAudio: !!audio,
          snapshot: hostSnapshot(host)
        });
        if (b) {
          try {
            b.click();
          } catch (e) {}
        } else if (audio && audio.paused) {
          try {
            audio.play();
          } catch (e2) {}
        }
        if (!playing(host) && n < 15) setTimeout(attempt, 900);
      }
      setTimeout(attempt, 1200);
    }
  
    function injectRadioEmbedStyles(root) {
      if (!root) return;
      var src = document.getElementById('radio-elfsight-embed-style');
      if (!src) return;
  
      function into(node) {
        if (!node) return;
        try {
          if (node.querySelector && node.querySelector('#radio-elfsight-embed-style')) return;
          node.appendChild(src.cloneNode(true));
        } catch (e) {}
      }
  
      into(root);
      if (root.shadowRoot) into(root.shadowRoot);
  
      queryDeep(root, '.es-embed-root, [class*="elfsight-app-"], .elfsight-host').forEach(function (el) {
        if (el.shadowRoot) into(el.shadowRoot);
      });
  
      try {
        root.querySelectorAll &&
          root.querySelectorAll('*').forEach(function (el) {
            if (el.shadowRoot) into(el.shadowRoot);
          });
      } catch (e2) {}
    }
  
    function radioContentReady(host) {
      if (!host) return false;
      if (controlsReady(host)) return true;
      if (widgetRendered(host)) return true;
      if (host.querySelector('.es-embed-root') && queryDeep(host, 'button, img, audio, [class*="PlayPause__"]').length) {
        return true;
      }
      return false;
    }
  
    function markRadioReady(wrap, host, force) {
      if (!wrap) return false;
      var slot = wrap.closest('[data-kt-header-player-mount]') || document.querySelector('[data-kt-header-player-mount]');
      injectRadioEmbedStyles(host);
      injectRadioEmbedStyles(wrap);
  
      var ready = !!force || radioContentReady(host);
      if (!ready) return false;
  
      wrap.setAttribute('data-kt-radio-ready', '1');
      if (slot) slot.setAttribute('data-kt-radio-ready', '1');
      return true;
    }
  
    function waitUntilReady(wrap, host, done) {
      var tries = 0;
      (function poll() {
        tries++;
        if (tries === 1 || tries % 5 === 0) injectRadioEmbedStyles(host);
        if (markRadioReady(wrap, host) || tries > 40) {
          if (tries > 40) markRadioReady(wrap, host, true);
          if (done) done();
          return;
        }
        setTimeout(poll, 100);
      })();
    }
  
    function mountRadio() {
      var slot = document.querySelector('[data-kt-header-player-mount]');
      if (!slot) return;
      if (slot.getAttribute('data-kt-radio-mounted') === '1') return;
  
      var inlineHost = slot.querySelector('.elfsight-host[data-kt-player-role="radio-page"]');
      if (inlineHost) {
        dbg('mountRadio inline slot');
        slot.setAttribute('data-kt-radio-mounted', '1');
        var wrap = inlineHost.closest('.header-elfsightplayer') || slot;
        wrap.classList.add('radio-page-moved');
        inlineHost.setAttribute('data-kt-player-role', 'radio-page');
        ensureApp(inlineHost, cfg().radio);
        setSession(true, shouldResume());
        injectRadioEmbedStyles(inlineHost);
        injectRadioEmbedStyles(slot);
  
        function nudgeLayout() {
          try {
            window.dispatchEvent(new Event('resize'));
          } catch (e) {}
          inlineHost.style.transform = 'translateZ(0)';
          requestAnimationFrame(function () {
            inlineHost.style.transform = '';
          });
        }
  
        ensurePlatform(function () {
          kickWidget(cfg().radio);
          bindControls();
          syncUi();
          resumeRadio();
          nudgeLayout();
          waitUntilReady(wrap, inlineHost, nudgeLayout);
        });
  
        var readyObs = new MutationObserver(function () {
          if (markRadioReady(wrap, inlineHost)) {
            nudgeLayout();
            readyObs.disconnect();
          }
        });
        readyObs.observe(inlineHost, { childList: true, subtree: true });
        return;
      }
  
      var wrap = document.querySelector('.header-elfsightplayer.desktop_player');
      if (!wrap || wrap.classList.contains('radio-page-moved')) return;
  
      slot.setAttribute('data-kt-radio-mounted', '1');
      dbg('mountRadio move from header');
      var host = wrap.querySelector('.elfsight-host');
      if (host) {
        host.setAttribute('data-kt-player-role', 'radio-page');
        ensureApp(host, cfg().radio);
        setSession(true, shouldResume());
      }
  
      if (!document.querySelector('[data-kt-header-player-placeholder]')) {
        var ph = document.createElement('div');
        ph.setAttribute('data-kt-header-player-placeholder', '');
        ph.style.minHeight = '18px';
        wrap.parentNode.insertBefore(ph, wrap);
      }
  
      wrap.classList.remove('desktop_player', 'mobile_player');
      wrap.style.cssText = 'display:flex;width:100%;max-width:100%;min-width:0';
      wrap.removeAttribute('data-kt-radio-ready');
      slot.removeAttribute('data-kt-radio-ready');
      slot.appendChild(wrap);
      wrap.classList.add('radio-page-moved');
      injectRadioEmbedStyles(host);
      injectRadioEmbedStyles(slot);
  
      function nudgeLayoutMove() {
        try {
          window.dispatchEvent(new Event('resize'));
        } catch (e) {}
        if (host) {
          host.style.transform = 'translateZ(0)';
          requestAnimationFrame(function () {
            host.style.transform = '';
          });
        }
      }
  
      ensurePlatform(function () {
        bindControls();
        syncUi();
        resumeRadio();
        nudgeLayoutMove();
        waitUntilReady(wrap, host, nudgeLayoutMove);
      });
  
      if (host) {
        var moveObs = new MutationObserver(function () {
          if (markRadioReady(wrap, host)) {
            nudgeLayoutMove();
            moveObs.disconnect();
          }
        });
        moveObs.observe(host, { childList: true, subtree: true });
      }
    }
  
    function start() {
      if (booting) return;
      booting = true;
      dbg('start', { cfg: cfg(), radioPage: isRadioPage() });
  
      initWidget(function () {
        booting = false;
        bindControls();
        syncUi();
        if (!syncTimer) syncTimer = setInterval(syncUi, isRadioPage() ? 800 : 2500);
        if (shouldResume() && isRadioSession()) resumeRadio();
        if (document.querySelector('[data-kt-header-player-mount]') && !isRadioPage()) mountRadio();
      });
    }
  
    window.KtElfsightRadioBridge = {
      boot: start,
      initRadioPage: function () {
        dbg('initRadioPage');
        document.body.classList.add('kt-radio-page-active');
        //mountStickyPlayer();
        mountRadio();
        start();
      },
      syncAllPlayers: syncUi,
      debugSnapshot: function () {
        var host = getHost();
        dbg('manual snapshot', hostSnapshot(host));
        return hostSnapshot(host);
      }
    };
  
    document.addEventListener('DOMContentLoaded', function () {
      dbg('DOMContentLoaded', { cfg: cfg() });
      if (document.body.classList.contains('kt-radio-page-active') || document.querySelector('[data-kt-header-player-mount]')) {
        start();
      } else {
        setTimeout(start, 100);
      }
    });
  
    document.addEventListener('shopify:section:load', function () {
      dbg('shopify:section:load');
      stickyMounted = false;
      setTimeout(function () {
        if (isRadioPage()) mountStickyPlayer();
        start();
      }, 150);
    });
  })();
  